
import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow } from '@legacy/App';

import cloneDeep from 'lodash/cloneDeep';
import { Enum } from '@app/app.model';

app.factory('AdditionalFieldsFactory', ['$http', 'settings', function ($http, settings) {
    return {

        getAdditionalFieldList: function () {
            return $http.get(settings.ApiURL + settings.AdditionalFieldsURL + "/list/");
        },
        getAdditionalFieldByKey: function (key) {
            return $http.get(settings.ApiURL + settings.AdditionalFieldsURL + "/" + key.FieldType + "/" + key.FieldLocation);
        },
        saveAdditionalField: function (additionalField) {
            return $http.put(settings.ApiURL + settings.AdditionalFieldsURL + "/additionalField", additionalField);
        },
        deleteAdditionalField: function (key) {
            return $http.delete(settings.ApiURL + settings.AdditionalFieldsURL + "/" + key.FieldType + "/" + key.FieldLocation);
        },
        getNewAdditionalField: function () {
            return $http.get(settings.ApiURL + settings.AdditionalFieldsURL + "/new");
        },
        getCompanyList: function () {
            return $http.get(settings.ApiURL + settings.CompanyURL)
        },
        getTimeLogTypeList: function () {
            return $http.get(settings.ApiURL + settings.TimeLogURL);
        },
        getLoadLocationTypes: function () {
            return $http.get(settings.ApiURL + settings.AdditionalFieldsURL + "/loadLocationTypes");
        },
        getFieldLocations: function () {
            return $http.get(settings.ApiURL + settings.AdditionalFieldsURL + "/fieldtypes");
        },
        getDataTypes: function () {
            return $http.get(settings.ApiURL + settings.AdditionalFieldsURL + "/datatypes");
        },
        getViewModeTypes: function () {
            return $http.get(settings.ApiURL + settings.AdditionalFieldsURL + "/viewmodetypes");
        }

    };
}]);

app.controller('AdditionalFieldsController', ['$scope', '$q', 'AdditionalFieldsFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal', '$filter',
    function ($scope, $q, AdditionalFieldsFactory, $rootScope, settings, masterFactory, $uibModal, $filter) {

        $rootScope.pageTitle = "Additional Fields";

        $scope.AdditionalFieldList = [];
        $scope.additionalField = {};

        $scope.newAdditionalField = {};

        $scope.companies = [];
        $scope.timeLogTypeList = [];

        $scope.error = "";
        $scope.modelState = [];
        $scope.isFormVisible = false;

        $scope.pageSize = 20;


        init(0);


        $scope.refreshGrid = function (pageIndex) {

            $('#gridAdditionalFields').dxDataGrid({
                dataSource: {
                    store: {
                        data: $scope.AdditionalFieldList,
                        type: 'array',
                        key: ['FieldType', 'FieldLocation']
                    }
                },
                noDataText: "No Additional Fields Found",
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                rowAlternationEnabled: false,
                contentReadyAction: grdReadyAction,
                selection: { mode: 'single' },
                paging: {
                    pageSize: $scope.pageSize,
                    pageIndex: pageIndex
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [10, 20, 30]
                },
                filterRow: {
                    visible: true
                },
                groupPanel: {
                    visible: false,
                },
                columns: [
                    {
                        caption: 'Title',
                        dataField: 'Title',
                        cssClass: 'Title',
                        dataType: 'string',
                        alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<span />')
                                .text(options.data.Title)
                                .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    },
                    {
                        caption: 'Data type',
                        dataField: 'DataType',
                        dataType: 'string',
                        lookup: {
                            dataSource: $scope.dataTypes,
                            displayExpr: 'name',
                            valueExpr: 'id'
                        },
                        alignment: 'center'
                    },
                    {
                        caption: 'Field location',
                        dataField: 'FieldLocation',
                        dataType: 'Number',
                        lookup: {
                            dataSource: $scope.fieldLocations,
                            displayExpr: 'name',
                            valueExpr: 'id'
                        },
                        alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<span />')
                                .text(getFieldLocationName(options.data.FieldLocation))
                                .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    }
                ],
                wordWrapEnabled: true,
                selectionChanged: function (selectedRowsInfo) {

                    $scope.error = "";

                    if (selectedRowsInfo.selectedRowsData[0] != null) {

                        $('#loadingModal').modal({ backdrop: 'static' });
                        $scope.isNewAdditionalField = false;

                        AdditionalFieldsFactory.getAdditionalFieldByKey({
                            FieldType: selectedRowsInfo.selectedRowsData[0].FieldType,
                            FieldLocation: selectedRowsInfo.selectedRowsData[0].FieldLocation
                        }).success(function (data) {

                            $scope.additionalField = data;

                            removeTemporaryVisibilities();

                            restoreVisibilities(data.Visibility, selectedRowsInfo.selectedRowsData[0].FieldLocation);

                            refreshViewModes();
                            $scope.refreshAdditionalFieldVisibility();

                            $scope.isFormVisible = true;
                            $scope.isDeleteVisible = true;
                            ToggleYellowToGreen();
                            $rootScope.pageTitle = "Additional Field";
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }).finally(function () {
                            $('#loadingModal').modal('hide');
                            $('#formFieldId').show();
                        });
                    }
                }

            });
        };


        $scope.addNewEntity = function () {
            removeTemporaryVisibilities();
            $rootScope.pageTitle = "New Additional Fields";
            $scope.isFormVisible = true;
            $scope.isNewAdditionalField = true;
            $scope.isDeleteVisible = false;
            $scope.additionalField = angular.copy($scope.newAdditionalField);

            //$scope.refreshGrid(0);
            refreshViewModes();
            $scope.refreshAdditionalFieldVisibility();
            $('#formFieldId').hide();

            ToggleGreenToYellow();            
        };


        $scope.confirmDeleteEntity = function () {
            $('#DeleteModal').modal({ backdrop: 'static' });
        };


        $scope.deleteEntity = function (value) {

            if (value == 0) {
                $('#DeleteModal').modal('hide');
            }
            else if (value == 1) {
                deleteAdditionalField();
            }
        };

        $scope.cancelForm = function () {
            removeTemporaryVisibilities();
            refreshViewModes();
            var dataGrid = $('#gridAdditionalFields').dxDataGrid('instance');
            dataGrid.clearSelection();
            $scope.isFormVisible = false;
            $scope.additionalFieldsForm.submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
        };

        $scope.reset = function () {

            resetAdditionalField();
            refreshViewModes();

            $scope.additionalFieldsForm.$setPristine();
            $scope.additionalFieldsForm.submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Additional Fields details were reset' });
        };


        $scope.submitForm = function () {
            $scope.error = '';

            $scope.additionalFieldsForm.FieldLocation.$setValidity('required',
                $scope.fieldLocations.map(function (fl) { return fl.id }).includes($scope.additionalField.FieldLocation));

            $scope.additionalFieldsForm.DataType.$setValidity('required',
                $scope.dataTypes.map(function (fl) { return fl.id }).includes($scope.additionalField.DataType));


            if ($scope.additionalFieldsForm.$valid) {

                saveAdditionalField();

                $scope.additionalFieldsForm.submitted = false;
            } else {
                $scope.additionalFieldsForm.submitted = true;
            }
        };



        $scope.refreshAdditionalFieldVisibility = function (pageIndex) {

            var dataSource, columns, element;

            $scope.selectedVisibilityRow = undefined;
            $scope.isFormVisibilityVisible = false;
            $scope.fieldLocationName = getFieldLocationName($scope.additionalField.FieldLocation);
            
            switch ($scope.fieldLocationName) {

                case "Load Location": {

                    element = '#gridLoadLocation';
                    dataSource = $scope.loadLocationTypes;
                    columns = [
                        {
                            caption: 'Type',
                            dataField: 'LoadLocationType',
                            cssClass: 'LoadLocationType',
                            dataType: 'number',
                            alignment: 'center'
                        }
                    ];

                    break;
                }

                case "Time Log": {

                    element = '#gridTimeLogs';
                    dataSource = $scope.timeLogTypeList;
                    columns = [
                        {
                            caption: 'Time Log',
                            dataField: 'TimeLogName',
                            cssClass: 'TimeLogName',
                            dataType: 'string',
                            alignment: 'center',
                            cellTemplate: function (container, options) {
                                $('<span />')
                                    .text(options.data.TimeLogName)
                                    .append("</br>")
                                    .appendTo(container);
                                container.addClass('grid-cell-align-left');
                            }
                        }
                    ];

                    break;
                }

                default: {

                    element = '#gridCompany';
                    dataSource = $scope.companies;
                    columns = [
                        {
                            width: 75,
                            caption: 'Id',
                            dataField: 'Id',
                            cssClass: 'Id',
                            dataType: 'number',
                            alignment: 'center',
                            sortIndex: 0,
                            sortOrder: 'asc'
                        },
                        {
                            caption: 'Company Name',
                            dataField: 'CompanyName',
                            cssClass: 'CompanyName',
                            dataType: 'string',
                            alignment: 'center',
                            sortIndex: 0,
                            sortOrder: 'asc',
                            cellTemplate: function (container, options) {
                                $('<span />')
                                    .text(options.data.name)
                                    .appendTo(container);
                                container.addClass('grid-cell-align-left');
                            }
                        }
                    ];

                }
            }

            columns.push({

                width: 40,
                caption: '',
                dataField: 'Visibility',
                dataType: 'string',
                alignment: 'center',
                headerFilter: {
                    allowSearch: false
                },
                allowFiltering: false,
                cellTemplate: function (container, options) {

                    if (options.data.$visibility && options.data.$visibility.IsVisible) {
                        $('<img src="assets/Content/Images/Icons/shown_field.png"  />')
                            .appendTo(container);
                    }

                    else {
                        $('<img src="assets/Content/Images/Icons/hidden_field.png"  />')
                            .appendTo(container);
                    }
                }
            });


            $(element).dxDataGrid({
                dataSource: dataSource,
                height: 470,
                showColumnLines: true,
                showRowLines: false,
                showBorders: false,
                rowAlternationEnabled: false,
                contentReadyAction: resetSelectionColumn,
                selection: { mode: 'single' },
                paging: {
                    pageSize: 10,
                    pageIndex: pageIndex
                },
                pager: {
                    showPageSizeSelector: false
                },
                filterRow: {
                    visible: true
                },
                groupPanel: {
                    visible: false,
                },
                columns: columns,
                wordWrapEnabled: true,
                selectionChanged: onVisibilitySelectionChange
            });


        };


        $scope.onFieldLocationChange = function () {

            refreshViewModes();
            $scope.refreshAdditionalFieldVisibility();
        }


        $scope.onShowFieldChange = function () {

            var afVisibility; var dataGrid;


            switch ($scope.fieldLocationName) {

                case "Load Location": {
                    afVisibility = $scope.additionalField.Visibility.filter(function (afv) {
                        return afv.LoadLocationType == $scope.selectedVisibilityRow.LoadLocationType;
                    });
                    if (!afVisibility.length) {
                        $scope.selectedVisibilityRow.$visibility.LoadLocationType = $scope.selectedVisibilityRow.LoadLocationType;
                    }
                    dataGrid = $('#gridLoadLocation').dxDataGrid('instance');
                    break;
                }

                case "Time Log": {
                    afVisibility = $scope.additionalField.Visibility.filter(function (afv) {
                        return $scope.selectedVisibilityRow.TimeLogType === afv.TimeLogType && $scope.selectedVisibilityRow.TimeLogId == afv.TimeLogId
                    });
                    if (!afVisibility.length) {
                        $scope.selectedVisibilityRow.$visibility.TimeLogId = $scope.selectedVisibilityRow.TimeLogId;
                        $scope.selectedVisibilityRow.$visibility.TimeLogType = $scope.selectedVisibilityRow.TimeLogType;
                    }
                    dataGrid = $('#gridTimeLogs').dxDataGrid('instance');
                    break;
                }

                case 'Order Detail': {

                    afVisibility = $scope.additionalField.Visibility.filter(function (afv) {
                        return afv.CompanyId == $scope.selectedVisibilityRow.Id;
                    });
                    if (!afVisibility.length) {
                        $scope.selectedVisibilityRow.$visibility.CompanyId = $scope.selectedVisibilityRow.Id;
                    }

                    $scope.selectedVisibilityRow.$visibility.IsVisible = Object.values($scope.selectedVisibilityRow.$visibility.OsrChecked).filter(v => v >= 0).length > 0;

                    dataGrid = $('#gridCompany').dxDataGrid('instance');
                    break;
                }

                default: {
                    afVisibility = $scope.additionalField.Visibility.filter(function (afv) {
                        return afv.CompanyId == $scope.selectedVisibilityRow.Id;
                    });
                    if (!afVisibility.length) {
                        $scope.selectedVisibilityRow.$visibility.CompanyId = $scope.selectedVisibilityRow.Id;
                    }
                    dataGrid = $('#gridCompany').dxDataGrid('instance');
                }
            }

            if (!afVisibility.length) {
                $scope.additionalField.Visibility.push($scope.selectedVisibilityRow.$visibility);
            }

            var pageIndex = dataGrid.pageIndex();
            $scope.refreshAdditionalFieldVisibility(pageIndex);
        }

        // Helping functions and events
        $(window).resize(function () {
            onWindowResize('#gridAdditionalFields', settings.GridMarginHeight);
        });


        collapsibleHeaderClickEvent($scope);

        $scope.closeAlert = function () {
            $scope.error = null;
        };

        $scope.closeModelStateErrors = function () {
            $scope.modelState = [];
        };

        $scope.clickHalfDiv = function (control) {
            masterFactory.setFocus(control);
        };


        // Initialization - this runs on load
        function init(pageIndex) {
            masterFactory.verifyAuthentication();


            $('#loadingModal').modal({ backdrop: 'static' });

            $q.all([

                AdditionalFieldsFactory.getFieldLocations().success(function (data) {

                    $scope.fieldLocations = data;

                }).error(function (data, status) {
                    masterFactory.setError(status, 'Error on loading FieldLocations: ' + data, $scope);
                }),

                AdditionalFieldsFactory.getDataTypes().success(function (data) {

                    $scope.dataTypes = data;

                }).error(function (data, status) {
                    masterFactory.setError(status, 'Error on loading DataTypes: ' + data, $scope);
                }),

                AdditionalFieldsFactory.getViewModeTypes().success(function (data) {

                    $scope.viewModeTypes = data.filter(d => d.id != 0);
                    $scope.viewModeTypesCopy = cloneDeep($scope.viewModeTypes);

                }).error(function (data, status) {
                    masterFactory.setError(status, 'Error on loading DataTypes: ' + data, $scope);
                }),

                AdditionalFieldsFactory.getNewAdditionalField().success(function (data) {

                    $scope.newAdditionalField = data;

                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),

                AdditionalFieldsFactory.getCompanyList().success(function (data) {

                    $scope.companies = data;

                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),

                AdditionalFieldsFactory.getTimeLogTypeList().success(function (data) {

                    $scope.timeLogTypeList = data;

                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),

                AdditionalFieldsFactory.getLoadLocationTypes().success(function (data) {

                    $scope.loadLocationTypes = data;

                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),

            ]).then(function () {

                AdditionalFieldsFactory.getAdditionalFieldList().success(function (data) {

                    $scope.AdditionalFieldList = data;
                    $scope.refreshGrid(pageIndex);

                }).error(function (data, status) {
                    masterFactory.setError(status, 'Error on loading Additional Field: ' + data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                })

            });

        }

        function grdReadyAction(e) {
            onWindowResize('#gridAdditionalFields', settings.GridMarginHeight);
        }

        function saveAdditionalField() {

            $scope.saveInProgress = true;

            $scope.additionalField.Visibility = $scope.additionalField.Visibility.filter(function (afv) {
                if (afv.OsrChecked) afv.Osr = Object.values(afv.OsrChecked).filter(v => v >= 0);
                return afv.IsVisible == true;
            });
            AdditionalFieldsFactory.saveAdditionalField($scope.additionalField)
                .success(function (data) {
                    $scope.closeModelStateErrors();
                    $scope.error = '';

                    AdditionalFieldsFactory.getAdditionalFieldList().success(function (data) {
                        $scope.AdditionalFieldList = data;

                        var dataGrid = $('#gridAdditionalFields').dxDataGrid('instance');
                        var pageIndex = dataGrid.pageIndex();
                        $scope.pageSize = dataGrid.pageSize();
                        $scope.refreshGrid(pageIndex);
                        $scope.refreshAdditionalFieldVisibility(0);

                        if ($scope.additionalField.FieldType > 0) {
                            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Additional Field successfully' });
                        }
                        else {
                            $scope.cancelForm();
                            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Additional Field successfully' });
                        }

                        $scope.saveInProgress = false;

                    }).error(function (data, status) {
                        masterFactory.setError(status, 'Error on loading Additional Field: ' + data, $scope);

                        $scope.saveInProgress = false;

                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    })

                })
                .error(function (data, status) {
                    masterFactory.setError(status, data, $scope);

                    $scope.saveInProgress = false;
                })
                .finally(function (data) {
                    $('#loadingModal').modal('hide');
                });

        }

        function resetAdditionalField() {

            if (!$scope.isNewAdditionalField) {
                $('#loadingModal').modal({ backdrop: 'static' });
                AdditionalFieldsFactory.getAdditionalFieldByKey({
                    FieldType: $scope.additionalField.FieldType,
                    FieldLocation: $scope.additionalField.FieldLocation
                }).success(function (data) {
                    $scope.additionalField = data;
                    $scope.refreshGrid(0);
                    $scope.refreshAdditionalFieldVisibility(0);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
            else {
                var dataGrid;

                switch ($scope.fieldLocationName) {

                    case "Load Location": {
                        dataGrid = $('#gridLoadLocation').dxDataGrid('instance');
                        break;
                    }

                    case "Time Log": {
                        dataGrid = $('#gridTimeLogs').dxDataGrid('instance');
                        break;
                    }

                    default: {
                        dataGrid = $('#gridCompany').dxDataGrid('instance');
                    }
                }

                dataGrid.clearSelection();
                angular.copy($scope.newAdditionalField, $scope.additionalField);

                removeTemporaryVisibilities();

                $scope.refreshGrid(0);
                $scope.refreshAdditionalFieldVisibility(0);
            }
        }

        function deleteAdditionalField() {

            AdditionalFieldsFactory.deleteAdditionalField({
                FieldType: $scope.additionalField.FieldType,
                FieldLocation: $scope.additionalField.FieldLocation
            }).success(function (data) {

                AdditionalFieldsFactory.getAdditionalFieldList().success(function (data) {

                    var dataGrid = $('#gridAdditionalFields').dxDataGrid('instance');
                    var pageIndex = dataGrid.pageIndex();
                    $scope.pageSize = dataGrid.pageSize();
                    $scope.AdditionalFieldList = data;
                    $scope.cancelForm();
                    $scope.refreshGrid(pageIndex);

                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Additional Fields successfully' });
                });

            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }

        function removeTemporaryVisibilities() {

            angular.forEach($scope.companies, function (v, key) {
                v.$visibility = undefined;
            });
            angular.forEach($scope.timeLogTypeList, function (v, key) {
                v.$visibility = undefined;
            });
            angular.forEach($scope.loadLocationTypes, function (v, key) {
                v.$visibility = undefined;
            });

        }

        function restoreVisibilities(visibilities, fieldLocation) {


            switch (getFieldLocationName(fieldLocation)) {

                case "Time Log": {

                    angular.forEach(visibilities, function (visibility, key) {

                        visibility.IsVisible = true;

                        if (visibility.TimeLogType > 0) {
                            var timeLogType = $filter('filter')($scope.timeLogTypeList, function (t) { return t.TimeLogType === visibility.TimeLogType && t.TimeLogId == visibility.TimeLogId });
                            if (timeLogType.length == 1) {

                                timeLogType[0].$visibility = visibility;
                                timeLogType[0].$visibilityKey = key;
                            }
                        }
                    });
                    break;
                }

                case "Load Location": {

                    angular.forEach(visibilities, function (visibility, key) {

                        visibility.IsVisible = true;

                        if (visibility.LoadLocationType > 0) {
                            var loadLocationType = $filter('filter')($scope.loadLocationTypes, function (l) { return l.LoadLocationType === visibility.LoadLocationType });
                            if (loadLocationType.length == 1) {

                                loadLocationType[0].$visibility = visibility;
                                loadLocationType[0].$visibilityKey = key;
                            }
                        }
                    });
                    break;

                }

                case "Order Detail": {

                    angular.forEach(visibilities, function (visibility, key) {

                        visibility.IsVisible = true;

                        if (visibility.CompanyId > 0) {
                            var company = $filter('filter')($scope.companies, function (c) { return c.Id === visibility.CompanyId });
                            if (company.length == 1) {

                                var osrChecked = {};

                                angular.forEach(visibility.Osr, function (osr, key) {
                                    switch (osr) {
                                        case 0: osrChecked['0'] = 0;
                                            break;
                                        case 1: osrChecked['1'] = 1;
                                            break;
                                        case 2: osrChecked['2'] = 2;
                                            break;
                                    }
                                });

                                visibility.OsrChecked = osrChecked;

                                company[0].$visibility = visibility;
                                company[0].$visibilityKey = key;
                            }
                        }
                    });
                    break;

                }

                default: {

                    angular.forEach(visibilities, function (visibility, key) {

                        visibility.IsVisible = true;

                        if (visibility.CompanyId > 0) {
                            var company = $filter('filter')($scope.companies, function (c) { return c.Id === visibility.CompanyId });
                            if (company.length == 1) {

                                company[0].$visibility = visibility;
                                company[0].$visibilityKey = key;
                            }
                        }
                    });
                }
            }
        }

        function onVisibilitySelectionChange(selectedRowsInfo) {
            var row = selectedRowsInfo.selectedRowsData[0];
            if (row != null) {

                $scope.selectedVisibilityRow = row;
                $scope.isFormVisibilityVisible = true;                

            }
        }

        function getFieldLocationName(fieldLocationValue) {

            var fieldLocation = $scope.fieldLocations.filter(function (fl) {
                return fl.id === fieldLocationValue;
            });

            if (fieldLocation.length == 1) {
                return fieldLocation[0].name;                
            }

            return '';
        }


        function refreshViewModes() {

            if ($scope.isNewAdditionalField) $scope.additionalField.ViewMode = [];

            switch ($scope.additionalField.FieldLocation) {
                case FieldLocationEng.LoadingDetail: {
                    $scope.viewModeTypes = $scope.viewModeTypesCopy.filter((t: Enum) =>
                        t.id == AdditionalFieldViewLocation.LoadingProductCompartment);
                    if ($scope.isNewAdditionalField) $scope.additionalField.ViewMode = [$scope.viewModeTypes[0].id];
                    break;
                }
                case FieldLocationEng.LoadingDetailPerProduct: {
                    $scope.viewModeTypes = $scope.viewModeTypesCopy.filter((t: Enum) =>
                        t.id == AdditionalFieldViewLocation.LoadingProductDetail);
                    if ($scope.isNewAdditionalField) $scope.additionalField.ViewMode = [$scope.viewModeTypes[0].id];
                    break;
                }
                case FieldLocationEng.OrderDetail: {
                    $scope.viewModeTypes = $scope.viewModeTypesCopy.filter((t: Enum) =>
                        t.id == AdditionalFieldViewLocation.OrderProductDetail);
                    if ($scope.isNewAdditionalField) $scope.additionalField.ViewMode = [$scope.viewModeTypes[0].id];
                    break;
                }
                case FieldLocationEng.LoadLocation: {
                    $scope.viewModeTypes = $scope.viewModeTypesCopy.filter((t: Enum) =>
                        t.id == AdditionalFieldViewLocation.LoadingLoadLocationProductCompartment);
                    if ($scope.isNewAdditionalField) $scope.additionalField.ViewMode = [$scope.viewModeTypes[0].id];
                    break;
                }
                case FieldLocationEng.Loading: {
                    $scope.viewModeTypes = $scope.viewModeTypesCopy.filter((t: Enum) =>
                        [
                            AdditionalFieldViewLocation.LoadingStart,
                            AdditionalFieldViewLocation.LoadingProductsDone
                        ].includes(t.id));
                    break;
                }
                case FieldLocationEng.TimeLog: {
                    $scope.viewModeTypes = $scope.viewModeTypesCopy.filter((t: Enum) =>
                        t.id == AdditionalFieldViewLocation.TimeLog);
                    if ($scope.isNewAdditionalField) $scope.additionalField.ViewMode = [$scope.viewModeTypes[0].id];
                    break;
                }
                case FieldLocationEng.Order: {
                    $scope.viewModeTypes = $scope.viewModeTypesCopy.filter((t: Enum) =>
                        [
                            AdditionalFieldViewLocation.OrderStart,
                            AdditionalFieldViewLocation.OrderProductsDone,
                            AdditionalFieldViewLocation.OrderAfterSignature,
                            AdditionalFieldViewLocation.OrderPrintSaleDone,
                            AdditionalFieldViewLocation.OrderRegisterReceiveScreen
                        ].includes(t.id));
                    break;
                }
                default: $scope.viewModeTypes = cloneDeep($scope.viewModeTypesCopy);
            }
        }

    }]);



export enum FieldLocationEng {
    Loading = 17, // 7 + 17
    LoadingDetail = 11, // 1 + 11
    LoadingDetailPerProduct = 19, // 9 + 19
    LoadLocation = 15, // 15

    Order = 18, // 8 + 18
    OrderDetail = 13,  // 3 + 13

    Sale = 14, // 4 + 14

    TimeLog = 16, // 16
}


export enum AdditionalFieldViewLocation {

    LoadingStart = 0x1,
    LoadingProductsDone = 0x2,
    LoadingProductDetail = 0x4,
    LoadingProductCompartment = 0x8,

    LoadingLoadLocationProductCompartment = 0x10, //16 

    OrderStart = 0x400, //1024
    OrderProductsDone = 0x800, //2048

    OrderAfterSignature = 0x1000, //4096
    OrderProductDetail = 0x2000, //8192
    OrderPrintSaleDone = 0x4000, //16384
    OrderRegisterReceiveScreen = 0x8000, //32768

    TimeLog = 0x100000, // 1048576
}


